import React, { useState } from "react";
import { Document, Page, pdfjs } from 'react-pdf';
import Text from './Text.js';
import Button from './Button.js';
import Loader from './Loader.js';

// these must be imported to fix a bug where dead space and extra random characters are renderered at the bottom of the pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

/**
 * @param props
 * @returns {*}
 * @constructor
 */
function PDFViewer(props) {
  const [pages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1); // setting 1 to show first page

  /**
   * @param pages
   */
  const onDocumentLoadSuccess = ({
    numPages
  }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  /**
   * @param offset
   */
  const changePage = offset => {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  };
  const {
    pdf,
    width,
    customStyle
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: '100%',
      height: 'auto',
      minHeight: '50vh',
      marginLeft: 'auto',
      marginRight: 'auto',
      ...customStyle
    }
  }, props.onDownload && /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    onClick: props.onDownload,
    customStyle: {
      display: 'block',
      marginLeft: 'auto',
      marginBottom: 1.25
    }
  }, "DOWNLOAD"), /*#__PURE__*/React.createElement(Document, {
    file: pdf,
    onLoadSuccess: onDocumentLoadSuccess,
    loading: /*#__PURE__*/React.createElement(Loader, {
      isContainer: true
    })
  }, /*#__PURE__*/React.createElement(Page, {
    pageNumber: pageNumber,
    width: width || 900
  })), pages > 1 && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: pageNumber <= 1,
    onClick: () => changePage(-1)
  }, "Previous"), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, "Page ", pageNumber || (pages ? 1 : "--"), " of ", pages || "--"), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: pageNumber >= pages,
    onClick: () => changePage(1)
  }, "Next")));
}
export default PDFViewer;